<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 text-primary font-weight-bold">Testimonials</h5>
      <br />
    </div>
    <b-card class="text-left">
      <h6 class="font-weight-bold">Create New Testimonial</h6>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Paxelian Name" label-for="input-1">
            <input
              placeholder="Paxelian Name"
              v-model="name"
              v-validate="'required|min:5|max:30'"
              name="name"
              data-vv-as="Name"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Job Title" label-for="input-1">
            <input
              placeholder="Job Title"
              v-model="job_title"
              v-validate="'required|min:5|max:30'"
              name="job_title"
              data-vv-as="Job Title"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('job_title') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Testimonial (Bahasa)" label-for="input-1">
            <textarea
              id="textarea"
              v-model="testimonial_id"
              v-validate="'required|min:5|max:30'"
              name="testimonial_id"
              data-vv-as="Testimonial Bahasa"
              class="form-control"
              placeholder="Testimonial In Bahasa Indonesia"
            ></textarea>
            <b-form-invalid-feedback
              id="input-title_en-feedback"
            >{{ veeErrors.first('testimonial_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Testimonial (English)" label-for="input-1">
            <textarea
              id="textarea"
              v-model="testimonial_en"
              v-validate="'required|min:5|max:30'"
              name="testimonial_en"
              data-vv-as="Testimonial English"
              class="form-control"
              placeholder="Testimonial In English"
            ></textarea>
            <b-form-invalid-feedback
              id="input-title_en-feedback"
            >{{ veeErrors.first('testimonial_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Photo" label-for="input-1"></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>
                  &nbsp;
                  {{!this.file ? 'Photo':this.file.name}}
                  <sup
                    class="text-secondary pl-3 mr-5 pr-5"
                  >(2 Mb)</sup>
                </b-col>
                <b-col class="text-right" align="right">
                  <input
                    type="file"
                    ref="file"
                    v-validate="'required|image|dimensions:500,500|size:2000|ext:jpg,png,gif,jpeg'"
                    name="image"
                    style="display: none"
                    v-on:change="onChangeFileUpload()"
                  />
                  <b-button
                    v-show="!file"
                    @click="$refs.file.click()"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="file"
                    variant="primary"
                    @click="modalImage = !modalImage"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.file.click()"
                    v-show="file"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col class="pr-0">
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              v-model="selected"
              :options="options2"
              data-vv-as="Status"
              v-validate="'required'"
              name="radio-options"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-options') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-right">
        <b-col>
          <b-button
            variant="primary"
            class="mr-3"
            :disabled="loading"
            @click="post()"
            size="lg"
          >Save</b-button>
          <router-link :to="{name: 'pxTestimonial'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: null,
      options2: [
        { text: 'Publish', value: 'publish' },
        { text: 'Archive', value: 'archive' },
      ],
      name: '',
      urlImage: '',
      modalImage: false,
      job_title: '',
      testimonial_id: '',
      testimonial_en: '',
      file: '',
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const formData = new FormData();
          formData.append('image', this.file);
          formData.append('name', this.name);
          formData.append('job_title', this.job_title);
          formData.append('testimonial_id', this.testimonial_id);
          formData.append('testimonial_en', this.testimonial_en);
          formData.append('status', this.selected);

          this.loading = true;
          this.$store
            .dispatch('testimonialModule/postTestimonial', formData)
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: 'pxTestimonial' });
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
      }
    },
  },
};
</script>

<style>
</style>
